import DealerDetails from './DealerDetails';

export default DealerDetails;
